import { createAction, props } from '@ngrx/store';

export const dismissIntroduction = createAction(
  '[Dismiss Introduction] Dismiss Introduction',
  props<{dismissedAt: Date}>(),
);
